module.exports = __webpack_public_path__ + "img/fh_slider1.8d45c88d.jpg";